import React, { Component } from 'react'
import { getUserDetails } from '../../../services/aws/aws-services';

export default class FallbackDashboardComponent extends Component {
	render() {
		const userDetails = getUserDetails();
        const { handleLogout } = this.props;
        return (
            <div className="data-list-tabs dashboard-blocks p-4">
                <h1 className="my-4 text-muted">Welcome {userDetails ? `${userDetails.given_name} ${userDetails.family_name}` : 'user'}</h1>
                <div className="mt-3">
                    <button className="btn btn-secondary my-2" type="button" onClick={handleLogout}>Log out</button>
                </div>
            </div>
        )
	}
}
